module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-07-ea8d7f54f529254c159520f45fd0d392.png";